import React, { createContext, useContext, ReactNode } from 'react';
import { useLanguageDetection, UseLanguageDetectionReturn } from '../hooks/useLanguageDetection';

// Create the language context
const LanguageContext = createContext<UseLanguageDetectionReturn | undefined>(undefined);

// Context provider component
interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const languageDetection = useLanguageDetection();

  return (
    <LanguageContext.Provider value={languageDetection}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use the language context
export const useLanguageContext = (): UseLanguageDetectionReturn => {
  const context = useContext(LanguageContext);
  
  if (context === undefined) {
    throw new Error('useLanguageContext must be used within a LanguageProvider');
  }
  
  return context;
};

// Export the context for direct access if needed
export { LanguageContext }; 